/*jshint bitwise:false */
define('util/ininAudioUtils',['lib/lodash4',
        'services/loggingService'
], function (_, LOG) {
    'use strict';

    var ininAudioUtils = {

        recommendedAudioFormat: null,

        mimeTypes: [
            {mimeType: 'audio/mpeg', formatId: 'mp3', native: true},
            {mimeType: 'audio/webm', formatId: 'webm', native: true},
            {mimeType: 'audio/wav', formatId: 'wav', native: true}
        ],

        probeNativeAudioSupport: function (force) {

            if(this.recommendedAudioFormat && !force) {
                return this.recommendedAudioFormat;
            }

            var audioElement = document.createElement('audio');
            var supportedType = null;

            if (audioElement) {
                supportedType = _(this.mimeTypes).find(function (c) {

                    if (audioElement.canPlayType && audioElement.canPlayType(c.mimeType)) {
                        LOG.info("Client can natively play " + c.mimeType + ", formatId=" + c.formatId);
                        return c;
                    }

                });
            }

            //Fallback to wav if nothing else works
            if (!supportedType) {

                var c =  {mimeType: 'audio/wav', formatId: 'wav', native: false};
                LOG.info("No natively playable mimeTypes found, using " + c.mimeType + ", formatId=" + c.formatId);
                supportedType = c;

            }

            this.recommendedAudioFormat = supportedType;

            return supportedType;

        },
        getSuggestedMimeType: function() {
            return this.probeNativeAudioSupport().mimeType;
        },
        getSuggestedFormatId: function() {
            return this.probeNativeAudioSupport().formatId;
        },
        getIsNativeFormatAvailable: function() {
            return this.probeNativeAudioSupport().native;

        },
        shouldSuggestWebm: function () {
            // This webm codec only works for IE, but detecting IE is hard.
            // Since we know that all other browsers we support work with
            // webm or wav, suggest webm codec in all other cases (IE).
            return (!this.getIsNativeFormatAvailable());
        }

    };

    return ininAudioUtils;
});

